import { useUserAvatarMapState } from "@/zustand/UserAvatarMapState";

/**
 * Returns the latest known avatar attachment ID for a given user.
 *
 * Resolution order:
 * 1. If the map has an entry for this user, use it (even if empty — tombstone
 *    from avatar deletion means "show initials", not "fall back to stale data").
 * 2. Otherwise fall back to the per-message/per-chat avatarId (useful before
 *    the map is populated on first load).
 */
export default function useUserAvatar(
  username: string,
  fallbackAvatarId?: string | null,
): string {
  const latestAvatarEntry = useUserAvatarMapState(
    (state) => state.avatarMap[username],
  );

  // Map entry exists → authoritative (even if attachmentId is "" = avatar deleted)
  if (latestAvatarEntry !== undefined) {
    return latestAvatarEntry.attachmentId;
  }

  // No map entry yet → fall back to per-message/per-chat data
  return fallbackAvatarId || "";
}
